<div class="site" [routerLink]="site.seoSlug">
	<div class="image-header">
		<img *ngIf="site.cardHeader; else old" [src]="site.cardHeader" alt="site banner" />
		<!-- Deprecate -->
		<ng-template #old>
			<div *ngIf="site && site.logoTitle && !site.logoURL">
				<img [src]="'/assets/img/logos/sites/icons/'+site.logoTitle+'.png'" />
			</div>
			<div *ngIf="site && headerImages[site.wpSlug]">
				<img [src]="headerImages[site.wpSlug]" /> 
			</div>
			<div *ngIf="site && !headerImages[site.wpSlug] && site.logoURL">
				<img [src]="site.logoURL"/>
			</div>
		</ng-template>
	</div>
	<div class="content">
		<div>
			<div class="site-name">{{ site.name }}</div>
			<div class="site-audience">
				<div class="audience">{{ site.combinedAudience? site.combinedAudience : '-' }}</div>
				<div class="audience-label">Combined Audience</div>
			</div>
			<div class="site-description">
				<p>{{ site.description }}</p>
			</div>
		</div>
		<div>
			<!-- <a href="" class="details-button">Details</a> -->
			<a class="select-button" [routerLink]="site.seoSlug">Learn More</a>
		</div>
	</div>
</div>
